import { OptionBadgeGroup } from '../components/OptionBadgeGroup';
import { MANAGE_OPTIONS } from '../constants';
import type { StepProps } from '../types';
import { useTranslation } from 'react-i18next';

export function StepManage({ answers, setAnswer }: StepProps) {
  const { t } = useTranslation('onboarding');
  const manageOptions = MANAGE_OPTIONS.map((option) => ({
    ...option,
    label: t(`manage.${option.id}`),
  }));
  return (
    <OptionBadgeGroup
      options={manageOptions}
      selected={answers.manage}
      onChange={(val) => setAnswer('manage', val)}
    />
  );
}
